import {
  listAvailableAlgorithms as publicListAvailableAlgorithms,
  getRecommendation as publicGetRecommendation,
} from './ecom-recommendations-v1-recommendation-recommendations.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listAvailableAlgorithms: MaybeContext<
  BuildRESTFunction<typeof publicListAvailableAlgorithms> &
    typeof publicListAvailableAlgorithms
> = /*#__PURE__*/ createRESTModule(publicListAvailableAlgorithms);
export const getRecommendation: MaybeContext<
  BuildRESTFunction<typeof publicGetRecommendation> &
    typeof publicGetRecommendation
> = /*#__PURE__*/ createRESTModule(publicGetRecommendation);

export { AlgorithmType } from './ecom-recommendations-v1-recommendation-recommendations.universal.js';
export {
  Recommendation,
  CatalogReference,
  Algorithm,
  ListAvailableAlgorithmsRequest,
  ListAvailableAlgorithmsResponse,
  AlgorithmInfo,
  AlgorithmConfig,
  GetRecommendationRequest,
  GetRecommendationResponse,
  ItemAppIdNotSupportedByProvider,
  RecommendationAlgorithmNotSupported,
  GetRecommendationOptions,
} from './ecom-recommendations-v1-recommendation-recommendations.universal.js';
export {
  AlgorithmTypeWithLiterals,
  GetRecommendationApplicationErrors,
} from './ecom-recommendations-v1-recommendation-recommendations.universal.js';
